import { apiUrl } from "../constans";
import apiClient from '../libs/axios';

const BASE = `${apiUrl}/v2/external-credentials`;

const externalCredential = {
    namespaced: true,
    state: {
        credentials: [],
        admins: [],
        loading: false,
    },
    mutations: {
        setCredentials(state, data) {
            state.credentials = Array.isArray(data) ? data : (data?.data || []);
        },
        setAdmins(state, admins) {
            state.admins = admins || [];
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
    },
    getters: {
        getCredentials: (state) => state.credentials,
        getAdmins: (state) => state.admins,
        isLoading: (state) => state.loading,
    },
    actions: {
        fetchCredentials({ commit }, params = {}) {
            commit('setLoading', true);
            return new Promise((resolve, reject) => {
                apiClient.get(BASE, { params })
                    .then(response => {
                        const data = response.data?.data ?? response.data;
                        const list = Array.isArray(data) ? data : (data?.data || []);
                        commit('setCredentials', list);
                        resolve(list);
                    })
                    .catch(reject)
                    .finally(() => commit('setLoading', false));
            });
        },

        // eslint-disable-next-line no-empty-pattern
        fetchCredential({}, id) {
            return new Promise((resolve, reject) => {
                apiClient.get(`${BASE}/${id}`)
                    .then(response => resolve(response.data?.data ?? response.data))
                    .catch(reject);
            });
        },

        // eslint-disable-next-line no-empty-pattern
        createCredential({}, payload) {
            return new Promise((resolve, reject) => {
                apiClient.post(BASE, payload)
                    .then(response => resolve(response.data?.data ?? response.data))
                    .catch(reject);
            });
        },

        // eslint-disable-next-line no-empty-pattern
        updateCredential({}, { id, payload }) {
            return new Promise((resolve, reject) => {
                apiClient.put(`${BASE}/${id}`, payload)
                    .then(response => resolve(response.data?.data ?? response.data))
                    .catch(reject);
            });
        },

        // eslint-disable-next-line no-empty-pattern
        deleteCredential({}, id) {
            return new Promise((resolve, reject) => {
                apiClient.delete(`${BASE}/${id}`)
                    .then(response => resolve(response.data))
                    .catch(reject);
            });
        },

        // eslint-disable-next-line no-empty-pattern
        syncCredential({}, id) {
            return new Promise((resolve, reject) => {
                apiClient.post(`${BASE}/${id}/sync`)
                    .then(response => resolve(response.data))
                    .catch(reject);
            });
        },

        // eslint-disable-next-line no-empty-pattern
        testCredential({}, id) {
            return new Promise((resolve, reject) => {
                apiClient.post(`${BASE}/${id}/test`)
                    .then(response => resolve(response.data?.data ?? response.data))
                    .catch(reject);
            });
        },

        // eslint-disable-next-line no-empty-pattern
        fetchStatus({}, id) {
            return new Promise((resolve, reject) => {
                apiClient.get(`${BASE}/${id}/status`)
                    .then(response => resolve(response.data?.data ?? response.data))
                    .catch(reject);
            });
        },

        // Lista de admins destino: reutiliza el listado de membresías (usuarios admin/padre)
        fetchAdmins({ commit }, filters = {}) {
            return new Promise((resolve, reject) => {
                apiClient.post(`${apiUrl}/v2/membersheps?page=1`, { per_page: 500, ...filters })
                    .then(response => {
                        const paginator = response.data?.data ?? response.data;
                        const rows = paginator?.data ?? paginator ?? [];
                        const admins = rows.map(u => ({
                            id: u.id,
                            email: u.email,
                            name: u.userdata?.primer_nombre || u.email,
                        }));
                        commit('setAdmins', admins);
                        resolve(admins);
                    })
                    .catch(reject);
            });
        },
    }
};

export default externalCredential;
